$(function() {
  $('.js-scroll-to').click(function (e) {
    e.preventDefault();

    var page = $(this).data('target'),
        speed = 750,
        menuHeight,
        windowWidth;

    function getWindowWith() {
      windowWidth = $(window).width();
    }

    getWindowWith();

    $(window).resize(function () {
      getWindowWith();
    });

    if (windowWidth >= 780) {
      menuHeight = 96;
    }
    else {
      menuHeight = 96;
    }

    if ($('#wpadminbar').length > 0) {
      menuHeight += 50;
    }

    var $page = $(page);
    var scrollTop = $page.offset().top;

    if (!$page.hasClass('u-anchor')) {
      scrollTop -= menuHeight;
    }

    $('html, body').animate({
      scrollTop: scrollTop
    }, speed);

    return false;
  });
});
